import { ADD_ATTENDANCE, ADD_ATTENDANCE_FAILED, ADD_ATTENDANCE_SUCCESS, ATTENDANCE, ATTENDANCE_FAILED, ATTENDANCE_SUCCESS, UPDATE_ATTENDANCE, UPDATE_ATTENDANCE_FAILED, UPDATE_ATTENDANCE_SUCCESS } from "./actionTypes"

let initialState = {
    attendance: [],
    addAttendance: "",
    updateAttendance: "",
    loading: false,
    success: false,
    error: ''
}

export const attendanceReducer = (state = initialState, action) => {
    switch (action.type) {

        case ATTENDANCE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ATTENDANCE_SUCCESS: return {
            ...state,
            attendance: action.payload,
            loading: false,
            success: true
        }
        case ATTENDANCE_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_ATTENDANCE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_ATTENDANCE_SUCCESS: return {
            ...state,
            addAttendance: action.payload,
            attendance: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ADD_ATTENDANCE_FAILED: return {
            ...state,
            addAttendance: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_ATTENDANCE: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_ATTENDANCE_SUCCESS: return {
            ...state,
            updateAttendance: action.payload,
            attendance: state?.attendance?.id == action.payload.id ? action.payload : state?.attendance,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_ATTENDANCE_FAILED: return {
            ...state,
            updateAttendance: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}